import { useState } from "react";

export const completedRunActionLabels = {
  finish: "Zu den Einstellungen",
  repeat: "Noch Mal",
} as const;

export async function executeCompletedRunAction(
  action: keyof typeof completedRunActionLabels,
  actions: { onFinish: () => Promise<void>; onRepeat: () => Promise<void> },
) {
  await (action === "finish" ? actions.onFinish() : actions.onRepeat());
}

export function CompletedRunActions({
  onFinish,
  onRepeat,
  onError,
}: {
  onFinish: () => Promise<void>;
  onRepeat: () => Promise<void>;
  onError: (message: string) => void;
}) {
  const [pending, setPending] = useState<"finish" | "repeat" | null>(null);

  async function run(action: "finish" | "repeat") {
    if (pending) return;
    setPending(action);
    try {
      await executeCompletedRunAction(action, { onFinish, onRepeat });
    } catch (error) {
      onError(error instanceof Error ? error.message : "Die Aktion konnte nicht ausgeführt werden.");
    } finally {
      setPending(null);
    }
  }

  return (
    <div className="completed-run-actions">
      <button className="primary" disabled={pending !== null} onClick={() => void run("finish")}>{completedRunActionLabels.finish}</button>
      <button className="secondary" disabled={pending !== null} onClick={() => void run("repeat")}>{completedRunActionLabels.repeat}</button>
    </div>
  );
}
